<template>
    <div class="popup">
        <div class="popup_div">
            <!-- 礼物动态区 -->
            <div id="demoCanvasT">

            </div>
        </div>
    </div>
</template>

<script>
    import SVGA from "svgaplayerweb"//引用svga
    export default {
        name: 'popup',
        data() {
            return {
                is_animation:true,//动画
                player:'',
                parser:"",
                num:0,
            }
        },
        props: {
            gift_arrT:{
                type:Array,
            },
        },
        methods: {
            SVGA() { 
                let demoCanvas = document.getElementById("demoCanvasT");
                let that = this;
                // demoCanvas.forEach((liem,index)=>{

                let player = new SVGA.Player(demoCanvas);
                let parser = new SVGA.Parser(demoCanvas);
                let num_att = 0;
                parser.load(this.$VIEW_URL+'/svga/闪开我要去学习.svga', function (videoItem) {
                    //this.bgImg，图片路径需要线上地址，本地引用会报错
                    //  
                    player.loops = 1;
                    player.clearsAfterStop = true;
                    player.setVideoItem(videoItem);
                    player.startAnimation();
                    player.onFrame(function (i) {
                        //  
                        num_att = i;
                    });
                    player.onFinished(function(){//动画结束
                         
                        player.stopAnimation();
                        that.is_animation = true;
                        that.downGift();
                        
                    })
                
                });
                
                
            },
            setFill() {               //适配不同屏
                let that = this;
                var $_canvas = document.getElementById("demoCanvasT"),
                w = $('#demoCanvasT').width(),
                h = $('#demoCanvasT').height(),
                screen_proportion = h / w,
                svga_proportion = 16 / 9;

                if (screen_proportion > svga_proportion) {
                    //长屏幕
                    // $_canvas.style.width = h / svga_proportion + "px";
                    // $_canvas.style.left = (w - h / svga_proportion) / 2 + "px";
                } else {
                    // $_canvas.style.height = w * svga_proportion + "px";
                    // $_canvas.style.top = (h - w * svga_proportion) / 2 + "px";
                }
            },
            downGift(){
                let that = this;
                if(this.gift_arrT.length>0 && this.is_animation){
                    this.is_animation = false;
                    this.$emit('giftFunT');
                    this.setFill();
                    this.$nextTick(()=>{
                        that.SVGA();
                    })
                }
                
            },

        },
        mounted() {
            this.downGift();
            
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .popup {
      
    }

    .popup .popup_div {
      
    }

    #demoCanvasT{
        width: 300px;
        height: 300px;
        position: absolute;
        top:0;
        left: 50%;
        transform: translateX(-50%);
        /* border:.005rem solid #ff0000; */
    }
</style>


// WEBPACK FOOTER //
// src/components/assembly/GiftT.vue